/**
 * Config del configJson de la feature `chatbot`.
 *
 * Esta config NO duplica los datos ricos del chatbot (catálogo, zonas,
 * knowledge, tokens de Twilio) — esos viven en el D1 del Worker
 * `chatbot-saas` (ficamar/chatbot). Acá sólo guardamos el **puntero** que
 * la UI de Atreus necesita para mostrar el estado y eventualmente sincronizar
 * el toggle live/paused con el otro Worker (Phase C, bridge HTTP).
 *
 * Las regex de `slug` y `whatsappNumber` espejan exactamente las del
 * onboard del chatbot (`ficamar/chatbot/src/tenants/onboard.ts`): si un
 * valor pasa acá, también pasa allá. Mantenerlas en sync es importante —
 * el flujo es: superadmin onboardea tenant en chatbot (CLI) → copia slug
 * → pega en Atreus al activar la feature.
 */
import { z } from 'zod';
export const chatbotConfigSchema = z.object({
    /** Slug del tenant en el D1 del chatbot. `lowercase-kebab-style`. */
    slug: z
        .string()
        .min(1, 'slug requerido')
        .max(100, 'slug demasiado largo')
        .regex(/^[a-z0-9-]+$/, 'slug debe ser lowercase a-z, 0-9 o dash'),
    /** Número en formato Twilio: `whatsapp:+<digits>` (8 a 15 dígitos). */
    whatsappNumber: z
        .string()
        .regex(/^whatsapp:\+\d{8,15}$/, 'formato esperado: whatsapp:+<digits> (ej: whatsapp:+573001234567)'),
    /**
     * Estado operativo. `pending` = activado en Atreus pero todavía no
     * confirmado con el chatbot. `live` = bot operativo. `paused` = el tenant
     * pidió pausarlo desde Atreus (queda como display, sin bridge todavía).
     */
    status: z.enum(['pending', 'live', 'paused']),
});
//# sourceMappingURL=chatbot.js.map